<div class="col">
  <app-header></app-header>
</div>
<div class="d-flex edit-profile-layout">
  <div class="col-md-3 edit-profile-sidebar d-none d-lg-block">
    <app-sidebar></app-sidebar>
  </div>
  <!-- <ngx-ui-loader [loaderId]="'loader-03'"></ngx-ui-loader> -->
  <div class="col-md-9 right-container edit-profile-content">
    <div class="mobile-edit-profile-sidebar-anchor">
      <div class="mobile-edit-profile-sidebar">
        <app-sidebar></app-sidebar>
      </div>
    </div>
    <div class="row">
      <div class="col p-0">
        <div class="card">
          <div class="mb-3 cover-image-container">
            <div class="container p-0">
              <ngx-ui-loader [loaderId]="'loader-01'"></ngx-ui-loader>
              <img [src]="renderImage(this.converPhoto)" (error)="getErrorImage($event)" alt="cover"
                class="img-fluid cover-image image" />
              <div class="middle">
                <div class="middle">
                  <div class="image-upload">
                    <label for="file-input1">
                      <small class="text">Change Cover</small>
                    </label>
                    <input id="file-input1" type="file" (change)="changeCoverPhoto($event)" />
                  </div>
                </div>
              </div>
            </div>
            <div class="profile-photo container">
              <ngx-ui-loader [loaderId]="'loader-02'"></ngx-ui-loader>
              <img [src]="renderImage(this.profilePhoto)" (error)="getErrorImage($event)" alt="profile-photo"
                class="img-fluid image" />
              <div class="middle">
                <div class="image-upload">
                  <label for="file-input">
                    <small class="text">Change Photo</small>
                  </label>
                  <input id="file-input" type="file" (change)="changeProfilePhoto($event)" />
                </div>
              </div>
            </div>
          </div>
          <div class="form-container px-4">
            <form #editProfileForm="ngForm" [formGroup]="editProfile" id="msform" (ngSubmit)="onSubmit()"
              autocomplete="off">
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputEmail1">Name <span class="asterisk">*</span></label>
                <input formControlName="name" type="name" class="form-control" id="exampleInputEmail1"
                  aria-describedby="emailHelp" placeholder="Enter name"
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.name?.invalid }" />
              </div>
              <div class="form-group">
                <label class="font-weight-bold">Username <span class="asterisk">*</span></label>
                <input formControlName="communityUserName" type="text" class="form-control" placeholder="Username"
                  [readonly]="!!initialCommunityUserName"
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.communityUserName?.invalid }" />
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Email <span
                    class="asterisk">*</span></label>
                <input formControlName="email" type="text" class="form-control" placeholder="Email" readonly />
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Main Phone Number <span
                    class="asterisk">*</span></label>
                <div class="d-flex">
                  <div class="mr-2" style="max-width: 130px;">
                    <select class="form-control" formControlName="countryCode">
                      <option value="+91">+91 (India)</option>
                      <option value="+1">+1 (USA/Canada)</option>
                      <option value="+44">+44 (UK)</option>
                      <option value="+61">+61 (Australia)</option>
                      <option value="+971">+971 (UAE)</option>
                    </select>
                  </div>
                  <div class="flex-grow-1">
                    <input type="text" formControlName="phone" class="form-control" id="exampleInputPassword12"
                      placeholder="Phone Number"
                      [ngClass]="{ 'is-invalid': submitted && editProfileInfo.phone?.invalid }" />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Alternate Number</label>
                <div class="d-flex">
                  <div class="mr-2" style="max-width: 130px;">
                    <select class="form-control" formControlName="alternateCountryCode">
                      <option value="+91">+91 (India)</option>
                      <option value="+1">+1 (USA/Canada)</option>
                      <option value="+44">+44 (UK)</option>
                      <option value="+61">+61 (Australia)</option>
                      <option value="+971">+971 (UAE)</option>
                    </select>
                  </div>
                  <div class="flex-grow-1">
                    <input formControlName="alternatecontactnumber" type="text" class="form-control"
                      id="exampleInputPassword1" placeholder="Alternate Number" />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Public Email <span class="asterisk">*</span></label>
                <input formControlName="publicemail" type="email" class="form-control" id="exampleInputPassword1"
                  placeholder="Public Email" required
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.publicemail?.invalid }" />
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Primary Address <span
                    class="asterisk">*</span></label>
                <input formControlName="address" type="text" class="form-control" placeholder="Address"
                  autocomplete="off" id="addressInput" ngx-google-places-autocomplete
                  (onAddressChange)="handleAddressChange($event, 'address')"
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.address?.invalid }" />
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Primary Address 2</label>
                <input formControlName="primaryAddress2" type="text" class="form-control" placeholder="Unit/Suite No."
                  autocomplete="off" id="primaryAddress2Input" />
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Secondary Address</label>
                <input formControlName="address2" type="text" class="form-control" id="address2Input"
                  placeholder="Address2" ngx-google-places-autocomplete
                  (onAddressChange)="handleAddressChange($event, 'address2')" />
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Secondary Address 2</label>
                <input formControlName="secondaryAddress2" type="text" class="form-control" placeholder="Unit/Suite No."
                  autocomplete="off" id="secondaryAddress2Input" />
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Slogan <span
                    class="asterisk">*</span></label>
                <input formControlName="logline" type="text" class="form-control" id="exampleInputPassword1"
                  placeholder="Slogan"
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.logline?.invalid }" />
              </div>
              <div class="form-group">
                <label class="font-weight-bold">Introduction <span class="asterisk">*</span></label>
                <textarea formControlName="introduction" class="form-control" rows="3" placeholder="Introduction"
                  style="resize: none" required
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.introduction?.invalid }"></textarea>
              </div>
              <div class="form-group">
                <label class="font-weight-bold">General Info <span class="asterisk">*</span></label>
                <textarea formControlName="generalInfo" class="form-control" rows="3" placeholder="General Info"
                  style="resize: none" required
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.generalInfo?.invalid }"></textarea>
              </div>
              <div class="form-group">
                <label class="font-weight-bold">Mission Statement</label>
                <textarea formControlName="missionStatement" class="form-control" rows="3"
                  placeholder="Mission Statement" style="resize: none"></textarea>
              </div>

              <div class="form-group">
                <label class="font-weight-bold" for="communityTypeSelect">
                  Ministry Type <span class="asterisk">*</span>
                </label>
                <ng-select [items]="communityType" bindLabel="name" bindValue="_id" [multiple]="true"
                  placeholder="Select community types" formControlName="communitytype" [closeOnSelect]="false"
                  [searchable]="true" [clearable]="true" id="communityTypeSelect"
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.communitytype?.invalid }">
                </ng-select>
              </div>
              <!-- 1st Level Faith -->
              <!-- ** Faith level 1 ** -->
              <div class="form-group mb-3">
                <label class="font-weight-bold">Faith <span class="asterisk">*</span></label>
                <ng-select [items]="faiths" formControlName="faith" bindLabel="name" bindValue="_id"
                  placeholder="Select Faith" [(ngModel)]="selectedFaith" (change)="changeFaithVal($event)"
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.faith?.invalid }">
                  <ng-template ng-header-tmp>
                    <small class="form-text text-muted">Loaded {{ skip1 }} of {{ faithTotalRecord }}</small>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    {{ item.name }}
                  </ng-template>
                </ng-select>
              </div>

              <!-- ** Faith level 2 (Branch) ** -->
              <div class="form-group mb-3" *ngIf="selectedFaith && subFaiths2.length > 0">
                <label class="font-weight-bold">Branch</label>
                <ng-select formControlName="subfaithBranch" [items]="subFaiths2" bindLabel="name" bindValue="_id"
                  [virtualScroll]="true" placeholder="Faith level 2" [(ngModel)]="subFaith2"
                  (change)="changeSubFaithBranch($event)">
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    {{ item.name }}
                  </ng-template>
                </ng-select>
              </div>

              <!-- ** Faith level 3 (Denomination) ** -->
              <div class="form-group mb-3" *ngIf="subFaith2 && faithDenomination.length > 0">
                <label class="font-weight-bold">Denomination</label>
                <ng-select formControlName="faithDenomination" [items]="faithDenomination" bindLabel="name"
                  bindValue="_id" [virtualScroll]="true" placeholder="Select Denomination">
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    {{ item.name }}
                  </ng-template>
                </ng-select>
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Tax ID No
                   <!-- <span
                    class="asterisk">*</span> -->
                  </label>
                <input formControlName="certificateno" type="text" class="form-control" id="exampleInputPassword1"
                  placeholder="Certificate No"
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.certificateno?.invalid }" />
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Candid (Guidestar) Link</label>
                <label class="w-100" for="">
                  <a target="_blank"
                    href="https://www.guidestar.org/search">https://www.guidestar.org/search</a></label>
                <textarea formControlName="guitarstarid" class="form-control" id="exampleFormControlTextarea1" rows="2"
                  maxlength="200" style="resize: none"></textarea>
              </div>
              <div class="form-group">
                <label for="exampleFormControlTextarea15545">Business registry or non-profit link</label>
                <textarea formControlName="bridgenumber" class="form-control" id="exampleFormControlTextarea15545"
                  rows="2" maxlength="200" style="resize: none"></textarea>
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Android App Link</label>
                <input formControlName="androidapplink" type="text" class="form-control" id="exampleInputPassword1"
                  placeholder="Android App Link" />
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">iOS App Link</label>
                <input formControlName="iOSappLInk" type="text" class="form-control" id="exampleInputPassword1"
                  placeholder="IOS app Link" />
              </div>


              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Country Of Registration <span class="asterisk">*</span></label>
                <input formControlName="countryofreg" type="text" class="form-control" id="exampleInputPassword1"
                  placeholder="Country Of Reg" required
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.countryofreg?.invalid }" />
              </div>
              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">Average Weekly Attendance <span class="asterisk">*</span></label>

                <select class="custom-select form-control" formControlName="avgweeklyattendance"
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.avgweeklyattendance?.invalid }">
                  <option value="" disabled selected>Select Weekly Attendance</option>
                  <option value="More than 2000 people">
                    More than 2000 People
                  </option>
                  <option value="Between 301-2000 people">
                    Between 301-2000 people
                  </option>
                  <option value="Between 51-300 people">
                    Between 51-300 people
                  </option>
                  <option value="50 or fewer people">50 or fewer people</option>
                  <option value="N/A">Not Applicable</option>
                </select>
              </div>

              <div class="form-group">
                <label class="font-weight-bold" for="exampleInputPassword1">
                  Association Status <span class="asterisk">*</span></label><input
                  [value]="getAssociationDisplayValue()" type="text" class="form-control" id="exampleInputPassword1"
                  placeholder="Select Association Status" (click)="
                    open(mymodal, 'What type of campus are you registering?')
                  " readonly
                  [ngClass]="{ 'is-invalid': submitted && editProfileInfo.associatedBy?.invalid }" />
                <div *ngIf="submitted && editProfileInfo.associatedBy.errors?.required" class="text-danger">
                  Association Status * required
                </div>
              </div>

              <div class="d-flex mx-auto justify-content-center mb-4">
                <button type="submit" class="btn btn-primary px-5 py-2 mt-3">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <ng-template #mymodal let-modal>
  <div class="modal-header main-backgroundcolor">
      <h4 class="modal-title color" id="modal-basic-title">{{Title | titlecase}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="color">&times;</span>
      </button>
  </div>
  <div class="modal-body">
      <div *ngIf="loading == false">
          <app-card-skelton *ngFor="let props of arr"></app-card-skelton>
      </div>
      <div *ngIf="loading">
          <div class="card margin-b" *ngFor="let props of loadMoreArr; let i = index">
              <div class="card-body border-r">
                  <div class="display">
                      <div class="image-wrapper">
                          <img [src]="props.photo" (error)="getErrorImage($event)">
                      </div>
                      <div class="text-area display justify-content1">
                          <div>
                              <h5 class="card-title">{{props.name}}</h5>
                              <p>{{(props.description | slice:0:35)}}</p>
                          </div>
                          <div class="form-check-input-inner">
                              <input type="checkbox" [value]="props._id"
                                  (change)="selectItem($event,props)" class="form-check-input"
                                  id="exampleCheck1">
                          </div>
                      </div>
                  </div>
              </div>

          </div>

          <h6 *ngIf="showError" class="error">{{modalError}}</h6>
      </div>
  </div>
  <div class="modal-footer">
      <button *ngIf="!staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
          (click)="modal.close('Save click')">
          Select</button>

      <button *ngIf="staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
          (click)="close(ministrymodal)">
          Select</button>
  </div>
</ng-template> -->

<ng-template #mymodal let-modal>
  <div class="modal-header main-backgroundcolor">
    <h4 class="modal-title color" id="modal-basic-title">
      {{ Title | titlecase }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="color">×</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Added search input for community selection modal -->
    <input *ngIf="Title === 'Select Ministry Headquarters'" type="text" class="form-control mb-3"
      placeholder="Search communities" (input)="search($event)" />
    <div *ngIf="loading == false">
      <app-card-skelton *ngFor="let props of arr"></app-card-skelton>
    </div>
    <div *ngIf="loading" class="text-center my-3">
      <div class="spinner-border text-primary" role="status">
      </div>
      <span class="visually-hidden">Loading...</span>
    </div>
    <!-- CHANGED: Show cards when data is available -->
    <div *ngIf="!loading && loadMoreArr.length > 0">
      <div class="card margin-b" *ngFor="let props of loadMoreArr; let i = index">
        <div class="card-body border-r">
          <div class="display">
            <div class="image-wrapper">
              <img [src]="props.photo" (error)="getErrorImage($event)" width="85px" />
            </div>
            <div class="text-area display justify-content1">
              <div>
                <h5 class="card-title" style="width: 250px;">{{ props.name }}</h5>
                <p>{{ props.description | slice : 0 : 35 }}</p>
              </div>
              <div class="form-check-input-inner">
                <input [type]="Title === 'Select Ministry Headquarters' ? 'checkbox' : 'radio'" [value]="props._id"
                  (change)="selectItem($event, props)" class="form-check-input" [id]="'option-' + i"
                  [checked]="Title === 'Select Ministry Headquarters' ? isHeadquarterSelected(props._id) : isOptionSelected(props.name)"
                  style="left: calc(100% - 20px);" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Pagination controls -->
      <nav aria-label="Page navigation" *ngIf="totalPages > 1">
        <ul class="pagination justify-content-center">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" href="#" (click)="previousPage()">Previous</a>
          </li>
          <li class="page-item" *ngFor="let page of totalPages | pageNumber:currentPage:5"
            [class.active]="page === currentPage">
            <a class="page-link" href="#" (click)="goToPage(page)">{{ page }}</a>
          </li>
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" href="#" (click)="nextPage()">Next</a>
          </li>
        </ul>
      </nav>
    </div>
    <!-- NEW: Empty state -->
    <div *ngIf="!loading && loadMoreArr.length === 0" class="text-center my-3">
      <p>No communities found.</p>
    </div>
    <!-- Added Load More button for community pagination -->
    <button *ngIf="showButton && Title === 'Select Ministry Headquarters'" class="btn btn-secondary"
      (click)="showMore()">
      Load More
    </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="!staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
      (click)="modal.close('Save click')">
      Select
    </button>
    <button *ngIf="staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
      (click)="close(mymodal)">
      Select
    </button>
  </div>
</ng-template>
